module.exports = __webpack_public_path__ + "img/logoFooter.54682ede.png";